export default function isFunction(fn) {
    return typeof fn === "function";
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-gauges/node_modules/@progress/kendo-charts/dist/es/common/is-function.js
// module id = 525
// module chunks = 29